import { Box } from "@mui/joy";
import React from "react";
import { theme } from "styles/theme";

interface ProgressBarProps {
  progress: number; // 0~100
}

export default function ProgressBar({
  progress,
}: ProgressBarProps) {
  const clampedProgress = Math.max(0, Math.min(progress ?? 0, 100));
  const barWidth = `clamp(0px, calc(${clampedProgress}% + 8px), 100%)`;
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        alignSelf: "center",
        width: "100%",
        height: "12px",
        backgroundColor: theme.vars.palette.Surface.Backward,
        borderRadius: "100px",
      }}
    >
      {/* 진행 바 */}
      <Box
        sx={{
          position: "absolute",
          left: 0,
          top: "50%",
          transform: "translateY(-50%)",
          height: "12px",
          // 이하 핵심: width를 “progress% + 8px” 하되 100%를 넘지 않도록 clamp
          width: barWidth,
          backgroundColor: theme.vars.palette.Surface.Highlight,
          borderRadius: "100px",
          transition: "width 0.3s ease",
          zIndex: 0,
        }}
      />

    </Box>
  );
}